// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"90393d28","65":"1287d570","141":"bc23f3e8","291":"379c0360","383":"cdc9f616","461":"fffecd5a","632":"64f28e13","689":"10e390de","717":"675d3fa7","821":"5c51a89b","960":"4e65a5f2"}[chunkId] + ".chunk.js";
};